// @flow

import React from 'react';
import ClickthroughOrCloseupLink from 'app/common/react/components/PinRep/components/ClickthroughOrCloseupLink';
import getPinSourceText from 'app/common/react/components/PinRep/utils/getPinSourceText';
import smartTruncate from 'app/common/lib/util/smartTruncate';
import Text from 'app/common/react/components/common/ExperimentalLegoGestalt/Text';
import { type Pin } from 'app/common/react/components/PinRep/types';

type Props = {|
  pin: Pin,
  singleLineMaxLength: number,
|};

export default function Source({ pin, singleLineMaxLength }: Props) {
  const text = getPinSourceText(pin);
  const truncatedSource = smartTruncate(text, singleLineMaxLength);

  const textContent = (
    <Text color="darkGray" data-test-id="PinRep-Source" overflow="normal" size="sm" weight="normal">
      {truncatedSource}
    </Text>
  );

  return <ClickthroughOrCloseupLink pin={pin}>{textContent}</ClickthroughOrCloseupLink>;
}
